// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2b00317c] .ag-icon-grip{position:absolute;pointer-events:auto;top:0;opacity:0;width:100%;height:100%}[data-v-2b00317c] .first-drag-column .ag-icon-grip{position:relative;top:12px;opacity:1}", ""]);
// Exports
module.exports = exports;
